module.exports = __webpack_public_path__ + "static/img/quan04.a9fbc24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/quan04.png
// module id = 7X/6
// module chunks = 0